module.exports = __webpack_public_path__ + "img/item_bookCover_10.68b27cd3.jpeg";